import { z } from "zod";

/* cognitoのパスワード要件
1. 8文字以上
2. 256文字以下
3. 以下の全てに合致するもの
	- 少なくとも1つの数字を含む
	- 少なくとも1つの特殊文字 (^ $ * . [ ] { } ( ) ? - " ! @ # % & / \ , > < ' : ; | _ ~ ` + =) を含む
	- 少なくとも 1 つの大文字を含む
	- 少なくとも 1 つの小文字を含む
*/
const newPasswordSchema = z
	.string()
	.trim()
	.min(8, "8文字以上で入力してください")
	.max(256, "256文字以下で入力してください")
	.regex(
		/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\-+=^$*.\[\]{}()?\"!@#%&\/\\\\,><\':;|_~`+=])(?!.*[^\x20-\x7E]).+$/,
		{
			message:
				"全角文字は使用せず、半角英小文字・半角英大文字・半角数字・特殊記号をそれぞれ1文字以上含めてください。",
		},
	);

export const newPasswordSettingFormSchema = z
	.object({
		newPassword: newPasswordSchema,
		newPasswordConfirm: newPasswordSchema,
	})
	.refine((data) => data.newPassword === data.newPasswordConfirm, {
		message: "パスワードが一致しません",
		path: ["newPasswordConfirm"],
	});
